import { render } from "./dshcy.vue?vue&type=template&id=109ef56c&scoped=true&ts=true"
import script from "./dshcy.vue?vue&type=script&lang=ts"
export * from "./dshcy.vue?vue&type=script&lang=ts"

import "./dshcy.vue?vue&type=style&index=0&id=109ef56c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109ef56c"]])

export default __exports__